export const insightsTabEnums = {
    OVERVIEW: 'OVERVIEW',
    DETAILED: 'DETAILED',
};

export const timeRangePresets = [
    { label: '1M', value: 1 },
    { label: '3M', value: 3 },
    { label: '6M', value: 6 },
    { label: '1Y', value: 12 },
];

export const displayModeEnums = {
    COUNT: 'COUNT',
    PERCENT: 'PERCENT',
};

/**
 * The goal's mastery line, from the goal's own settings (`goalMastery.count` = % of its targets that must be mastered).
 * No line when the goal does not auto-master or has no count — there is no benchmark to draw.
 */
export const getGoalMasteryLine = (goalMastery, isPercent, totalCount) => {
    // `totalCount` should be the targets the % is taken over now (latest point's `totalCount`: DISCONTINUED excluded).
    const percent = goalMastery?.automastery !== false ? goalMastery?.count : null;
    if (percent === null || percent === undefined) return null;
    if (isPercent) return { value: percent, label: `Goal mastery (${percent}%)` };
    const count = Math.ceil(((totalCount || 0) * percent) / 100);
    return { value: count, label: `Goal mastery (${count})` };
};

export const goalStatusColors = {
    ACTIVE: '#00C48C',
    MASTERED: '#0062FF',
    PENDING: '#FFB946',
    HOLD: '#6B7280',
    DISCONTINUED: '#FF6B6B',
};

export const targetStatusColors = {
    PENDING: '#FFB946',
    BASELINE: '#A855F7',
    TEACHING: '#3B82F6',
    MASTERED: '#00C48C',
    DISCONTINUED: '#FF6B6B',
    HOLD: '#6B7280',
};

export const domainColors = [
    '#3B82F6',
    '#8B5CF6',
    '#F97316',
    '#00C48C',
    '#FF6B6B',
    '#FFB946',
    '#6366F1',
    '#EC4899',
    '#14B8A6',
    '#A855F7',
    '#F59E0B',
    '#10B981',
];

export const datePresets = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'This Week', value: 'thisWeek' },
    { label: 'Last Week', value: 'lastWeek' },
    { label: 'This Month', value: 'thisMonth' },
    { label: 'Last Month', value: 'lastMonth' },
];

export const goalStatusList = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Mastered', value: 'MASTERED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Hold', value: 'HOLD' },
    { label: 'Discontinued', value: 'DISCONTINUED' },
];

export const targetStatusList = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Baseline', value: 'BASELINE' },
    { label: 'Teaching', value: 'TEACHING' },
    { label: 'Mastered', value: 'MASTERED' },
    { label: 'Discontinued', value: 'DISCONTINUED' },
    { label: 'Hold', value: 'HOLD' },
];
